<template>
	<div class="jump-link-anchor" :id="sectionId">
		<slot></slot>
	</div>
</template>

<script lang="ts" setup>
defineProps<{ sectionId: string }>();
</script>
